























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  FormVaildateToOut,
  IsMore
} from "@root/lib/decorator";

const k2Coupon = namespace("k2Coupon");
const common = namespace("common");
const root = namespace("root");

@Component({
  components: {}
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@FormVaildateToOut()
export default class CouponDetail extends Vue {
  @k2Coupon.Action queryCouponStatisticsDetailList;
  @k2Coupon.Action exportCouponStatisticsDetail;
  @k2Coupon.State detailMonth;
  @k2Coupon.State status;
  @k2Coupon.Mutation setDetailMonth;
  @k2Coupon.Mutation setStatus;
  @common.Action getDict;
  @common.State wtDicCodes;
  @common.Action queryDictList;
  @root.State ddCodes;
  total: any = 0;

  couponTypeList: any = [];
  form: any = {
    storeNameOrCode: "",
    // shopNameOrCode: "",
    couponType: "",
    couponName: "",
    receiveTime: null,
    usedTime: null,
    status: "",
    couponCode: "",
    couponSource: "",
    sourceType: []
    // receiveStartTime: "",
    // receiveEndTime: "",
    // usedStartTime: "",
    // usedEndTime: "",
  };
  activeTabName = "";
  statusTabs = [];
  searchParams: any = {};
  dataList = [];
  sourceTypeMap: any = {};
  sourceTypeList: any[] = [];
  gtExportDialog = false;

  created() {
    this.getDefaultDate();
  }

  async mounted() {
    if (this.detailMonth && this.detailMonth.length > 0) {
      this.form.usedTime = this.detailMonth;
      this.form.status = this.status;
      if (this.form.status) {
        this.activeTabName = this.form.status;
      }
      this.setDetailMonth(null);
      this.setStatus("");
    }
    this.init();
  }

  async init() {
    Promise.all([
      this.getData(),
      this.getDicFn(),
      this.getGraphqlDicFn(),
      this.getSourceTypeDicFn()
    ]);
    // this.getData();
    // this.getDicFn();
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    try {
      let { receiveTime, usedTime, status, ...others } = this.form;
      let input: any = {
        couponStatus: status,
        ...others,
        shopNameOrCode: localStorage.getItem("memberCode")
      };
      if (receiveTime) {
        if (receiveTime[0]) {
          input.receiveStartTime = receiveTime[0];
        }
        if (receiveTime[1]) {
          input.receiveEndTime = receiveTime[1];
        }
      }
      if (usedTime) {
        if (usedTime[0]) {
          input.usedStartTime = usedTime[0];
        }
        if (usedTime[1]) {
          input.usedEndTime = usedTime[1];
        }
      }
      this.searchParams = input;
      let res = await this.queryCouponStatisticsDetailList({
        ...input,
        pageSize,
        pageNum
      });
      this.total = res.total;
      this.dataList = res.list;
      // .map((item) => {
      //   item.deliveredTime = dayjs(item.deliveredTime).format(
      //     "YYYY-MM-DD HH:mm:ss"
      //   );
      //   return item;
      // });
    } catch (err) {
      this.dataList = [];
      this.total = 0;
    }
  }

  handleTabClick(val) {
    this.form.status = val;
    console.log(this.form.status, val, "--handleTabClick");
    (this as any).handlePageChange(1);
  }

  // 导出
  async exportFn(params = {}) {
    const input: any = {
      exportType: "1",
      shopNameOrCode: localStorage.getItem("memberCode"),
      ...params
    };
    const formData = new FormData();
    formData.append("AUTH-TOKEN", localStorage.getItem("AUTH-TOKEN-K-ONE-CN"));

    for (let i in input) {
      const value = input[i];
      if (Array.isArray(value)) {
        value.forEach(item => formData.append(i, item));
      } else if (value !== undefined && value !== null && value !== "") {
        formData.append(i, value);
      }
    }
    await this.exportCouponStatisticsDetail(formData);
  }

  async getDicFn() {
    let res = await this.getDict({
      dictCodes: ["COUPON_STATUS_SHOW"]
    });
    let list: any = this.wtDicCodes["COUPON_STATUS_SHOW"] || [];
    let result: any = [{ label: "全部", value: "" }];
    list.forEach(_ => {
      result.push({
        label: _.dictDesc,
        value: _.dictValue
      });
    });
    this.statusTabs = result;
  }

  async getGraphqlDicFn() {
    await this.$dd.register(["COUPON_TYPE"]).query();
    this.couponTypeList = this.ddCodes["COUPON_TYPE"] || [];
  }
  async getSourceTypeDicFn() {
    const {
      data: { list = [] }
    } = await this.queryDictList({
      dataCode: "COUPON_STATISTICS_SOURCE_TYPE_WT"
    });
    this.sourceTypeList = list;
    this.sourceTypeMap = {};
    this.sourceTypeList.forEach(item => {
      this.sourceTypeMap[item.dataValue] = item.dataDesc;
    });
  }

  // 格式化时间
  formatDate(datetime) {
    const time = new Date(datetime);
    const year = time.getFullYear();
    const month = (time.getMonth() + 1).toString().padStart(2, "0");
    const date = time.getDate().toString().padStart(2, "0");
    return year + "-" + month + "-" + date;
  }
  getDefaultDate() {
    this.form.receiveTime = [];
    const start = new Date();
    this.$set(
      this.form.receiveTime,
      0,
      this.formatDate(start.getTime() - 1000 * 3600 * 24 * 90) + " 00:00:00"
    );
    this.$set(
      this.form.receiveTime,
      1,
      this.formatDate(start.getTime()) + " 23:59:59"
    );
  }
}
